export default {
    isLogin: false,
    configData: {},
    baseQuotes: {},
    updateQuotes: {},
    innerHeight: null,
    symbolList: [],
    showBalance: true,
    investData: [],
    userInfo: {},
    language: "",
    rateList: [],
    currentRate: {},
    authInfo: {},
    themeType: "",
    languages: [],
    isApp: false,
    lastPrice:{}
}